export default {"src":"/_next/static/media/Group-25832.3462d6e4.svg","height":130,"width":130};